import { Controller } from "@hotwired/stimulus"

// 회원가입 아이디 중복확인. PHP 는 member/idcheck.php 팝업을 띄웠다.
export default class extends Controller<HTMLElement> {
  static targets = ["input", "message"]
  static values = { url: String }

  declare readonly inputTarget: HTMLInputElement
  declare readonly messageTarget: HTMLElement
  declare readonly urlValue: string

  async check(): Promise<void> {
    const loginId = this.inputTarget.value.trim()
    this.render("확인 중…", "text-slate-500")

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("login_id", loginId)

      const response = await fetch(url, { headers: { Accept: "application/json" } })
      if (!response.ok) throw new Error(String(response.status))

      const data = (await response.json()) as { available: boolean; message: string }
      this.render(data.message, data.available ? "text-emerald-600" : "text-rose-600")
    } catch {
      this.render("확인에 실패했습니다. 잠시 후 다시 시도해 주세요.", "text-rose-600")
    }
  }

  private render(message: string, colorClass: string): void {
    this.messageTarget.textContent = message
    this.messageTarget.className = `mt-1 text-xs ${colorClass}`
  }
}
